import React from 'react';
import moment from 'moment-timezone';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ProgressBar from 'react-bootstrap/ProgressBar';

import { MembershipCardImage } from './MembershipCard';

import { HorizontallyCenteringContainer, VerticalSeparator } from './utils';
import { parseMemberData } from './utils';

export default function TierStatusProgress({ memberData }) {
    const { tierCode, currentCycleInfo, totalCycleSpending } = parseMemberData(memberData);
    const cycEndDate = currentCycleInfo?.CycEndDate;
    const cycEndDatePlus12Mth = cycEndDate && (
        (Number(cycEndDate.split('-')[0])+1).toString() + '-' + cycEndDate.split('-').slice(1).join('-')
    );

    return <>
        {
            (tierCode === 'CR Member') && !!cycEndDate && (
                <>
                    <HorizontallyCenteringContainer>
                        <p className="app-text">
                            <strong>Your Status</strong>
                        </p>
                    </HorizontallyCenteringContainer>
                    <HorizontallyCenteringContainer>
                        <p className="app-text">
                            (through {moment(cycEndDate).format('DD MMM YYYY')})
                        </p>
                    </HorizontallyCenteringContainer>
                    <HorizontallyCenteringContainer>
                        <p className="app-text xxl">
                            ${totalCycleSpending.toFixed(2)}/$1000
                        </p>
                    </HorizontallyCenteringContainer>
                    <HorizontallyCenteringContainer>
                        <p className="app-text">
                            to unlock Cool Rewards SuperStar
                        </p>
                    </HorizontallyCenteringContainer>

                    <VerticalSeparator height='1em' />

                    <Container>
                        <Row>
                            <Col xs={10} style={{ paddingLeft: '0px', paddingRight: '0px' }}>
                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignContent: 'center',
                                    flexDirection: 'column',
                                    height: '30px',
                                }}>
                                    <ProgressBar
                                        min={0} max={1000}
                                        now={Math.min(1000, Math.floor(totalCycleSpending))}
                                        animated={true} />
                                </div>
                            </Col>
                            <Col xs={2} style={{ paddingLeft: '5px', paddingRight: '0px' }}>
                                <MembershipCardImage
                                    tierCode='CR SuperStar'
                                    width='45px' />
                            </Col>
                        </Row>
                    </Container>

                    <VerticalSeparator height='1em' />

                    <HorizontallyCenteringContainer>
                        <p className="app-text">
                            You're only <span style={{ fontWeight: 'bolder', textDecoration: 'underline' }}>${(1000 - totalCycleSpending).toFixed(2)}</span> from becoming a
                        </p>
                    </HorizontallyCenteringContainer>
                    <HorizontallyCenteringContainer>
                        <p className="app-text" style={{ fontWeight: 'bolder', color: 'var(--swensens-brand-color)' }}>
                            Cool Rewards SuperStar
                        </p>
                    </HorizontallyCenteringContainer>
                    <VerticalSeparator height='1em' />
                    <HorizontallyCenteringContainer>
                        <p className="app-text">
                            Upgrade to <strong>SuperStar</strong> to enjoy
                        </p>
                    </HorizontallyCenteringContainer>
                    <HorizontallyCenteringContainer>
                        <p className="app-text">
                            higher tier Rebate$, and <a style={{ color: 'var(--swensens-brand-color)' }} href="https://swensens.com.sg/be-a-member/#et_pb_toggle_title:~:text=How%20do%20I%20upgrade%20to%20be%20a%20Cool%20Rewards%20Superstar%3F" target="_blank" rel="noreferrer">more</a>!
                        </p>
                    </HorizontallyCenteringContainer>
                </>
            )
        }
        {
            (tierCode === 'CR SuperStar') && !!cycEndDate && (
                <>
                    <HorizontallyCenteringContainer>
                        <p className="app-text">
                            <strong>Your Cool Rewards SuperStar Status</strong>
                        </p>
                    </HorizontallyCenteringContainer>
                    <HorizontallyCenteringContainer>
                        <p className="app-text">
                            (valid till {moment(totalCycleSpending >= 1000 ? cycEndDatePlus12Mth : cycEndDate).format('DD MMM YYYY')})
                        </p>
                    </HorizontallyCenteringContainer>

                    <VerticalSeparator height='1em' />

                    {
                        totalCycleSpending < 1000 && (
                            <>
                                <HorizontallyCenteringContainer>
                                    <p className="app-text xxl">
                                        ${totalCycleSpending.toFixed(2)}/$1000
                                    </p>
                                </HorizontallyCenteringContainer>
                                <VerticalSeparator height='1em' />
                            </>
                        )
                    }

                    <Container>
                        <Row>
                            <Col xs={10} style={{ paddingLeft: '0px', paddingRight: '0px' }}>
                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignContent: 'center',
                                    flexDirection: 'column',
                                    height: '30px',
                                }}>
                                    <ProgressBar
                                        min={0} max={1000}
                                        now={Math.min(1000, Math.floor(totalCycleSpending))}
                                        animated={true} />
                                </div>
                            </Col>
                            <Col xs={2} style={{ paddingLeft: '5px', paddingRight: '0px' }}>
                                <MembershipCardImage
                                    tierCode='CR SuperStar'
                                    width='45px' />
                            </Col>
                        </Row>
                    </Container>

                    <VerticalSeparator height='1em' />

                    {
                        totalCycleSpending < 1000 && (
                            <>
                                <HorizontallyCenteringContainer>
                                    <p className="app-text">
                                        You are only <span style={{ fontWeight: 'bold', textDecoration: 'underline' }}>${(1000 - totalCycleSpending).toFixed(2)}</span> from extending your SuperStar status for 12 months
                                    </p>
                                </HorizontallyCenteringContainer>
                                <VerticalSeparator height='1em' />
                                </>
                        )
                    }

                    <HorizontallyCenteringContainer>
                        <p className="app-text">
                            Maintain <strong>SuperStar</strong> status to enjoy
                        </p>
                    </HorizontallyCenteringContainer>
                    <HorizontallyCenteringContainer>
                        <p className="app-text">
                            higher Rebate$, and <a style={{ color: 'var(--swensens-brand-color)' }} href="https://swensens.com.sg/be-a-member/#et_pb_toggle_title:~:text=How%20do%20I%20upgrade%20to%20be%20a%20Cool%20Rewards%20Superstar%3F" target="_blank" rel="noreferrer">more</a>!
                        </p>
                    </HorizontallyCenteringContainer>
                </>
            )
        }
    </>;
}